export enum ClientExtractLoanPartRedemptionMethodEnum {
  Annuity = 'Annuity',
  Linear = 'Linear',
  AtOnce = 'AtOnce',
  Other = 'Other',
  GermanAnnuity = 'GermanAnnuity',
}
